import { Outlet } from "react-router-dom";
import style from "./MainUserLayout.module.scss";
import { Footer, Header, Menu } from "../components";
import { MenuLink } from "layout/components/Menu/components";
import { useUserLogoutMutation } from "@RTKQuery/user/auth/auth";
import { StatisticsCollection } from "./components";

export function MainUserLayout() {
  const [userLogout] = useUserLogoutMutation();

  return (
    <div id="layout" className={style.layout}>
      <div  className={style.zoom}>
        <Header
          balance
          userId
        />
        <div id="zoom" className={style.flexBox}>
          <Menu
            linksGroups={[
              {
                nameGroup: "Меню",
                links: [
                  <MenuLink
                    link="/"
                    key={0}
                    label="Мої Проксі"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M13.7497 3.66667H16.4997C16.7428 3.66667 16.9759 3.76324 17.1479 3.93515C17.3198 4.10706 17.4163 4.34022 17.4163 4.58333V18.3333C17.4163 18.5764 17.3198 18.8096 17.1479 18.9815C16.9759 19.1534 16.7428 19.25 16.4997 19.25H5.49967C5.25656 19.25 5.0234 19.1534 4.85149 18.9815C4.67959 18.8096 4.58301 18.5764 4.58301 18.3333V4.58333C4.58301 4.34022 4.67959 4.10706 4.85149 3.93515C5.0234 3.76324 5.25656 3.66667 5.49967 3.66667H8.24968M8.24968 6.41667H13.7497M8.24968 11H13.7497M8.24968 14.6667H13.7497M9.16634 2.75V6.41667H12.833V2.75H9.16634Z"
                          stroke="#D4EAFF"
                          strokeWidth="1.83333"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                  />,
                  <MenuLink
                    link="/buy-proxy"
                    key={1}
                    label="Купити проксі"
                    icon={
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.91997 9V5C7.91997 4.20435 8.23604 3.44129 8.79865 2.87868C9.36126 2.31607 10.1243 2 10.92 2C11.7156 2 12.4787 2.31607 13.0413 2.87868C13.6039 3.44129 13.92 4.20435 13.92 5V9M16.92 7L17.837 18.923C17.8476 19.0604 17.8297 19.1985 17.7844 19.3287C17.7391 19.4588 17.6674 19.5782 17.5738 19.6793C17.4802 19.7805 17.3666 19.8611 17.2404 19.9163C17.1141 19.9715 16.9778 20 16.84 20H4.99997C4.86216 20 4.72584 19.9715 4.59956 19.9163C4.47329 19.8611 4.35978 19.7805 4.26616 19.6793C4.17255 19.5782 4.10084 19.4588 4.05555 19.3287C4.01026 19.1985 3.99236 19.0604 4.00297 18.923L4.91997 7H16.92Z" stroke="#D4EAFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    }
                  />,
                  <MenuLink
                    link="/balance?tab=replenish"
                    key={2}
                    label="Поповнити баланс"
                    icon={
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M16 7H4M16 7C16.2652 7 16.5196 7.10536 16.7071 7.29289C16.8946 7.48043 17 7.73478 17 8V10.6M16 7L12 3M4 7C3.73478 7 3.48043 7.10536 3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H16C16.2652 19 16.5196 18.8946 16.7071 18.7071C16.8946 18.5196 17 18.2652 17 18V15.4M4 7L8 3L12 7M18 11H14C13.4696 11 12.9609 11.2107 12.5858 11.5858C12.2107 11.9609 12 12.4696 12 13C12 13.5304 12.2107 14.0391 12.5858 14.4142C12.9609 14.7893 13.4696 15 14 15H18C18.2652 15 18.5196 14.8946 18.7071 14.7071C18.8946 14.5196 19 14.2652 19 14V12C19 11.7348 18.8946 11.4804 18.7071 11.2929C18.5196 11.1054 18.2652 11 18 11Z" stroke="#D4EAFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    }
                  />,
                  <MenuLink
                    link="/referral-program"
                    key={3}
                    label="Реферальна програма"
                    icon={
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M15.5 10.875H20M17.75 13.125V8.625M2 17.625V16.5C2 15.6049 2.35558 14.7464 2.98851 14.1135C3.62145 13.4806 4.47989 13.125 5.375 13.125H9.875C10.7701 13.125 11.6286 13.4806 12.2615 14.1135C12.8944 14.7464 13.25 15.6049 13.25 16.5V17.625C13.25 17.9234 13.1315 18.2095 12.9205 18.4205C12.7095 18.6315 12.4234 18.75 12.125 18.75H3.125C2.82663 18.75 2.54048 18.6315 2.32951 18.4205C2.11853 18.2095 2 17.9234 2 17.625ZM11 6.375C11 7.27011 10.6444 8.12855 10.0115 8.76149C9.37855 9.39442 8.52011 9.75 7.625 9.75C6.72989 9.75 5.87145 9.39442 5.23851 8.76149C4.60558 8.12855 4.25 7.27011 4.25 6.375C4.25 5.47989 4.60558 4.62145 5.23851 3.98851C5.87145 3.35558 6.72989 3 7.625 3C8.52011 3 9.37855 3.35558 10.0115 3.98851C10.6444 4.62145 11 5.47989 11 6.375Z" stroke="#D4EAFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    }
                  />,
                ]
              },
              {
                nameGroup: "Інше",
                links: [
                  <MenuLink
                    link="/settings"
                    key={4}
                    label="Налаштування"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M20 12V10C20 9.73478 19.8946 9.48043 19.7071 9.29289C19.5196 9.10536 19.2652 9 19 9H18.243L17.536 7.293L18.071 6.757C18.2585 6.56947 18.3638 6.31516 18.3638 6.05C18.3638 5.78484 18.2585 5.53053 18.071 5.343L16.657 3.929C16.4695 3.74153 16.2152 3.63621 15.95 3.63621C15.6848 3.63621 15.4305 3.74153 15.243 3.929L14.707 4.464L13 3.757V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2H10C9.73478 2 9.48043 2.10536 9.29289 2.29289C9.10536 2.48043 9 2.73478 9 3V3.757L7.293 4.464L6.757 3.929C6.56947 3.74153 6.31516 3.63621 6.05 3.63621C5.78484 3.63621 5.53053 3.74153 5.343 3.929L3.929 5.343C3.74153 5.53053 3.63621 5.78484 3.63621 6.05C3.63621 6.31516 3.74153 6.56947 3.929 6.757L4.465 7.293L3.757 9H3C2.73478 9 2.48043 9.10536 2.29289 9.29289C2.10536 9.48043 2 9.73478 2 10V12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H3.757L4.464 14.707L3.929 15.243C3.74153 15.4305 3.63621 15.6848 3.63621 15.95C3.63621 16.2152 3.74153 16.4695 3.929 16.657L5.343 18.071C5.53053 18.2585 5.78484 18.3638 6.05 18.3638C6.31516 18.3638 6.56947 18.2585 6.757 18.071L7.293 17.536L9 18.243V19C9 19.2652 9.10536 19.5196 9.29289 19.7071C9.48043 19.8946 9.73478 20 10 20H12C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19V18.243L14.707 17.535L15.243 18.071C15.4305 18.2585 15.6848 18.3638 15.95 18.3638C16.2152 18.3638 16.4695 18.2585 16.657 18.071L18.071 16.657C18.2585 16.4695 18.3638 16.2152 18.3638 15.95C18.3638 15.6848 18.2585 15.4305 18.071 15.243L17.536 14.707L18.243 13H19C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12Z"
                          stroke="#D4EAFF"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11 14C11.7956 14 12.5587 13.6839 13.1213 13.1213C13.6839 12.5587 14 11.7956 14 11C14 10.2044 13.6839 9.44129 13.1213 8.87868C12.5587 8.31607 11.7956 8 11 8C10.2044 8 9.44129 8.31607 8.87868 8.87868C8.31607 9.44129 8 10.2044 8 11C8 11.7956 8.31607 12.5587 8.87868 13.1213C9.44129 13.6839 10.2044 14 11 14Z"
                          stroke="#D4EAFF"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                  />,
                  <MenuLink
                    link="/support"
                    key={5}
                    label="Підтримка"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M13.079 5.839C12.7937 5.56502 12.457 5.35018 12.0883 5.20683C11.7196 5.06349 11.3262 4.99448 10.9307 5.00378C10.5352 5.01307 10.1455 5.10048 9.78395 5.26099C9.42239 5.42149 9.09615 5.65192 8.824 5.939M12 19H13.083C13.5974 19.0001 14.1068 18.8989 14.5821 18.7021C15.0574 18.5053 15.4893 18.2168 15.853 17.853C16.2168 17.4893 16.5053 17.0574 16.7021 16.5821C16.8989 16.1068 17.0001 15.5974 17 15.083V8C17 6.4087 16.3679 4.88258 15.2426 3.75736C14.1174 2.63214 12.5913 2 11 2C9.4087 2 7.88258 2.63214 6.75736 3.75736C5.63214 4.88258 5 6.4087 5 8V15M12 19V18C12 17.7348 11.8946 17.4804 11.7071 17.2929C11.5196 17.1054 11.2652 17 11 17H10C9.73478 17 9.48043 17.1054 9.29289 17.2929C9.10536 17.4804 9 17.7348 9 18V19C9 19.2652 9.10536 19.5196 9.29289 19.7071C9.48043 19.8946 9.73478 20 10 20H11C11.2652 20 11.5196 19.8946 11.7071 19.7071C11.8946 19.5196 12 19.2652 12 19ZM5 15V9H4C3.46957 9 2.96086 9.21071 2.58579 9.58579C2.21071 9.96086 2 10.4696 2 11V13C2 13.5304 2.21071 14.0391 2.58579 14.4142C2.96086 14.7893 3.46957 15 4 15H5ZM17 9H18C18.5304 9 19.0391 9.21071 19.4142 9.58579C19.7893 9.96086 20 10.4696 20 11V13C20 13.5304 19.7893 14.0391 19.4142 14.4142C19.0391 14.7893 18.5304 15 18 15H17V9Z"
                          stroke="#D4EAFF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                  />,
                  <MenuLink
                    onClick={() => {
                      userLogout()
                    }}
                    key={6}
                    label="Вихід"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M17.4998 14L20.9998 11M20.9998 11L17.4998 8M20.9998 11H8.99976M14.3748 5.65466V5.60022C14.3748 4.3401 14.3748 3.70957 14.1295 3.22828C13.9138 2.8049 13.5699 2.46095 13.1465 2.24524C12.6652 2 12.0346 2 10.7745 2H5.59953C4.33942 2 3.71021 2 3.22893 2.24524C2.80559 2.46095 2.46044 2.8049 2.24478 3.22828C1.99976 3.7091 1.99976 4.33886 1.99976 5.59652V16.4041C1.99976 17.6617 1.99976 18.2906 2.24478 18.7714C2.46044 19.1947 2.80559 19.5393 3.22893 19.755C3.70976 20 4.33863 20 5.59627 20H10.7782C12.0359 20 12.6657 20 13.1465 19.755C13.5699 19.5393 13.9138 19.1944 14.1295 18.771C14.3748 18.2898 14.3748 17.6601 14.3748 16.4V16.3438"
                          stroke="#D4EAFF"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                  />
                ]
              }
            ]}
          />
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}
